import * as requestFromServer from "./addonAndSponsorshipApis";
import Actions from "../../actions";

// update sponsor -> api
export const getSystemSettingsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getSystemSettings();
  if (response) {
    setLoading(false);
    dispatch(Actions.createAction(Actions.GET_ALL_SYSTEM_SETTINGS, {systemSettings:response}))
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// organization top listing subscription plan -> api
export const getOrganizationTopListingSubscriptionPlanAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getOrganizationTopListingSubscriptionPlan(dataToBeSent);
  if (response) {
    setLoading(false);
    dispatch(Actions.createAction(Actions.GET_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_LIST, {organizationTopListingSubscriptionPlans:response}))
    return response;
  } else {
    setLoading(false);
    return null;
  }
};
